<template>
  <div class="print" style="display: block">
    <!-- main -->
    <div class="col-12 main">
      <div class="row no-printable">
        <div class="col-12 mb-2">
          <div class="title-admin mt-0">
            <h1 class="display-3 font-weight-black">Gastos</h1>
            <v-btn color="red darken-1" dark large @click="$router.go(-1)"
              ><v-icon class="mr-3">close</v-icon>Salir</v-btn
            >
          </div>
        </div>
      </div>

      <!-- filtrar bar -->
      <div class="row mt-4 filtrar-admin no-printable">
        <div class="col-4">
          <v-dialog
            ref="dialog"
            v-model="modal"
            :return-value.sync="desde"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="desde"
                label="Desde"
                prepend-icon="event"
                readonly
                outlined
                background-color="#ffffff"
                v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker v-model="desde">
              <v-btn text color="primary" @click="$refs.dialog.save(desde)"
                >OK</v-btn
              >
              <v-btn text color="primary" @click="modal = false"
                >Cancelar</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </div>

        <div class="col-4">
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="hasta"
            persistent
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="hasta"
                label="Hasta"
                prepend-icon="event"
                readonly
                outlined
                v-on="on"
              ></v-text-field>
            </template>

            <v-date-picker v-model="hasta">
              <v-btn text color="primary" @click="$refs.dialog2.save(hasta)"
                >OK</v-btn
              >
              <v-btn text color="primary" @click="modal2 = false"
                >Cancelar</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </div>

        <div class="col-4 d-flex justify-space-between mt-1">
          <v-btn @click="getGastosFiltrados()" large color="grey" dark>
            <v-icon class="mr-3">settings_overscan</v-icon>Filtrar
          </v-btn>
          <v-btn @click="resetFiltro()" outlined large color="grey" dark
            >Borrar filtro</v-btn
          >
        </div>
      </div>
      <!-- /filtrar bar -->

      <!-- tabla de ventas -->
      <div class="row mt-0 mb-5">
        <div class="col-12">
          <div>
            <div
              class="top d-flex align-items-center justify-content-between mb-3"
            >
              <h5
                class="font-weight-black"
                v-if="showDesdeTitle && !showHastaTitle"
              >
                Todos las gastos de la fecha {{ desde }}
                <br />
                <h1 class="font-weight-black">
                  Total: ${{ total_gastos_dia }}
                </h1>
              </h5>
              <h5
                class="font-weight-black"
                v-if="showDesdeTitle && showHastaTitle"
              >
                Todos los gastos desde la fecha {{ desde }} hasta {{ hasta }}
                <br />
                <h1 class="font-weight-black">
                  Total: ${{ total_gastos_rango }}
                </h1>
              </h5>
              <h2 class="font-weight-black" v-if="!showDesdeTitle">
                Todos los gastos
              </h2>

              <v-btn @click="print" large color="primary">
                <v-icon class="mr-3">print</v-icon>Imprimir
              </v-btn>
            </div>

            <!-- loader -->
            <div v-if="loaderVentas" class="text-center loader-wrap-min">
              <div
                class="spinner-border text-primary"
                style="width: 75px; height: 75px"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <!-- /loader -->

            <div v-if="!loaderVentas">
              <!-- datatable -->
              <v-card v-if="ventas != ''">
                <v-card-title>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="gastos"
                  :search="search"
                >
                  <template v-slot:item.acciones="{ item }">
                    <v-btn
                      class="mx-2"
                      text
                      dark
                      small
                      color="primary"
                      :to="'/admin/gasto/' + item.id + '/editar'"
                    >
                      <v-icon dark>visibility</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card>
              <!-- /datatable -->

              <!-- vacio -->
              <div v-if="ventas == ''">
                <div class="vacio">
                  <span>No hemos encontrado ventas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /tabla de ventas -->
    </div>
    <!-- /main -->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
const axios = require("axios");

export default {
  components: { DatePicker },
  data() {
    return {
      gastos: [],
      loader: true,
      buscar: "",
      desde: "",
      hasta: "",

      //date picker
      modal: false,
      desde: "",
      modal2: false,
      hasta: "",

      total_gastos_dia: "",
      total_gastos_rango: "",

      desde: "",
      showDesdeTitle: false,
      showHastaTitle: false,
      hasta: "",

      //Table
      search: "",
      headers: [
        {
          text: "#ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        { text: "Descripción", value: "descripcion" },
        { text: "Monto", value: "monto" },
        { text: "Fecha", value: "fecha" },
        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    getGastosFiltrados() {
      if (this.desde == "" && this.hasta == "") {
        //No seleccionó ningún campo
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Selecciona la fecha deseada",
          showConfirmButton: true,
        });
      } else if (this.desde != "" && this.hasta == "") {
        //Necesita ventas por día
        this.loader = true;
        this.showDesdeTitle = true;

        //Traemos ventas del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastosFiltradosPorDia" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            console.log(response);
            this.gastos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));

        //Traemos el total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalGastosDia" +
              "&dia=" +
              this.desde
          )
          .then((response) => {
            this.total_gastos_dia = response.data.total;
          })
          .catch((error) => console.log(error));
      } else if (this.desde == "" && this.hasta != "") {
        //Solo seleccionó la fecha hasta
        this.$swal({
          type: "error",
          customClass: "arriba",
          title:
            "Selecciona la fecha 'Desde' para crear un reporte por rango de fecha",
          showConfirmButton: true,
        });
      } else if (this.desde !== "" && this.hasta !== "") {
        //Necesita fecha por rango
        this.loader = true;
        this.showDesdeTitle = true;
        this.showHastaTitle = true;

        //Traemos las ventas por rango de fecha

        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastosFiltradosPorRangoFecha" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            console.log(response);
            this.gastos = response.data;
            this.loader = false;
          })
          .catch((error) => console.log(error));

        //Traemos total del día
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getTotalGastosRangoFecha" +
              "&desde=" +
              this.desde +
              "&hasta=" +
              this.hasta
          )
          .then((response) => {
            this.total_gastos_rango = response.data.total;
          })
          .catch((error) => console.log(error));
      }
    },
    resetFiltro() {
      this.getGastos();
      this.desde = "";
      this.hasta = "";
      this.showDesdeTitle = false;
      this.showHastaTitle = false;
    },

    getGastos() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastos"
        )
        .then((response) => {
          console.log(response);
          this.gastos = response.data;
          this.loader = false;
        })
        .catch((error) => console.log(error));
    },
    print() {
      window.print();
    },
  },
  mounted() {
    this.getGastos();
  },
};
</script>
